var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequirement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.75H7.25",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 14.75H9.75",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 19.75H16",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "homeIcon",
    d: "M17.2559 13.5C13.8046 13.5 11.0059 10.7025 11.0059 7.25C11.0059 3.87 13.8809 0.996254 17.2609 1C20.7109 1.0025 23.5059 3.8 23.5059 7.25C23.5059 10.7013 20.7071 13.5 17.2559 13.5",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "homeIcon",
    d: "M17.25 7.5625V10.0625",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "homeIcon",
    d: "M17.2546 4.47273C17.1584 4.47273 17.0809 4.55023 17.0821 4.64648C17.0821 4.74273 17.1596 4.82023 17.2559 4.82023C17.3521 4.82023 17.4296 4.74273 17.4296 4.64648C17.4284 4.55023 17.3509 4.47273 17.2546 4.47273",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 12.9813V22.25C19.75 23.6313 18.6313 24.75 17.25 24.75H3.5C2.11875 24.75 1 23.6313 1 22.25V7.25C1 5.86875 2.11875 4.75 3.5 4.75H11.5512",
    stroke: "#939EAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirement);
export default __webpack_public_path__ + "static/media/requirement.136af961.svg";
export { ForwardRef as ReactComponent };